import { Component, OnInit } from '@angular/core';

import { WizardService } from '@sondermind/flows-host';

@Component({
  selector: 'sonder-flow-input',
  templateUrl: './app-input.component.html',
  styleUrls: ['./app-input.component.scss'],
})
export class AppInputComponent implements OnInit {
  constructor(
    public wizardSvc: WizardService,
  ) { }

  ngOnInit() {
    console.log('initializing match-flow input');
  }

  startFlow(firstName: string) {
    const initialData = [];
    if (firstName && firstName.trim().length > 0) {
      initialData.push({
        human: 'First Name', key: 'contactFirstName', value: firstName
      });
    }

    this.wizardSvc.start(initialData).subscribe(() => {
      this.wizardSvc.toggleRunning(true);
    });
  }
}
